// What a record's page shows of it, keyed by that record's conversation: sent with each message
// there, so Arc works from the screen (unsaved changes included) rather than the saved record.
const pageStates = new Map<string, object>()

export const setArcPageState = (channelId: string, state: object | null) => {
  if (state) pageStates.set(channelId, state)
  else pageStates.delete(channelId)
}

export const arcPageStateFor = (channelId: string): object | undefined => pageStates.get(channelId)
